import { Flex, FlexProps, Text, TextProps } from "@chakra-ui/react";
import { ellipsisAnimation, shimmerGradient } from "@root/utils/animations";

interface ShimmeringStatusTextProps extends FlexProps {
  message: string;
  gradient?: string;
  shimmerDuration?: string;
  ellipsis?: boolean;
  ellipsisDuration?: string;
  textProps?: TextProps;
}

const ShimmeringStatusText = ({
  message,
  gradient = "linear-gradient(93.39deg, #1A1A1A -2.83%, #919191 51.53%, #595959 90.28%)",
  shimmerDuration = "3s",
  ellipsis = true,
  ellipsisDuration = "1.4s",
  textProps,
  ...flexProps
}: ShimmeringStatusTextProps) => {
  const { _after, textAlign, ...restTextProps } = textProps || {};

  const defaultAfterStyles = {
    content: '"..."',
    display: "inline-block",
    overflow: "hidden" as const,
    whiteSpace: "nowrap" as const,
    width: "0ch",
    marginLeft: "4px",
    animation: `${ellipsisAnimation} ${ellipsisDuration} steps(4, end) infinite`,
  };

  const afterStyles = ellipsis
    ? {
        ...defaultAfterStyles,
        ...(typeof _after === "object" && _after !== null ? _after : {}),
      }
    : _after;

  return (
    <Flex alignItems="center" py="24px" {...flexProps}>
      <Text
        fontWeight={600}
        fontSize="16px"
        lineHeight="20px"
        letterSpacing="-0.01em"
        textAlign={textAlign ?? "left"}
        bgGradient={gradient}
        bgClip="text"
        color="transparent"
        backgroundSize="200% 200%"
        animation={`${shimmerGradient} ${shimmerDuration} ease-in-out infinite`}
        display="inline-flex"
        alignItems="center"
        {...restTextProps}
        _after={afterStyles}
      >
        {message}
      </Text>
    </Flex>
  );
};

export default ShimmeringStatusText;
